import { cn } from '@cannect/lib/utils'
import { Typography } from '@cannect/new-components/atoms'
import { ElementType, ReactNode } from 'react'

type TAppointmentFeatureCard = {
  icon: ElementType
  title: string | ReactNode
  subtitle?: string | ReactNode
  classNames?: {
    icon?: string
    title?: string
    subtitle?: string
  }
}

export const AppointmentFeatureCard = ({ icon: IconElement, title, subtitle, classNames }: TAppointmentFeatureCard) => {
  return (
    <div className="flex w-full min-w-[200px] flex-col gap-4 rounded-lg border border-gray-200 bg-white p-6 shadow-none sm:min-w-[220px] md:min-w-[240px]">
      {/* Ícone no topo */}
      <div className="flex justify-start">
        {IconElement && (
          <IconElement className={cn('h-8 w-8 text-primary-700 sm:h-9 sm:w-9', classNames?.icon)} />
        )}
      </div>

      {/* Textos centralizados */}
      <div className="flex flex-col gap-1">
        {typeof title === 'string' ? (
          <Typography.Text weight="semibold" className={cn('text-base leading-tight text-neutral-800 sm:text-lg', classNames?.title)}>
            {title}
          </Typography.Text>
        ) : (
          title
        )}

        {subtitle && (
          <div>
            {typeof subtitle === 'string' ? (
              <Typography.Text
                type="paragraphTwo"
                className={cn('text-sm leading-relaxed text-neutral-600 sm:text-base', classNames?.subtitle)}>
                {subtitle}
              </Typography.Text>
            ) : (
              subtitle
            )}
          </div>
        )}
      </div>
    </div>
  )
}
